import { Component, Input } from '@angular/core';

import { DataRow } from '@fcom/common/interfaces';
import { toISOStringPreserveTimeZone } from '@fcom/common-booking/utils/date-utils';

import { XColumnType } from './x-column-type';
import { XColumn } from './x-column';

@Component({
  selector: 'fin-corporate-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss'],
})
export class CorporateDataTableComponent {
  protected readonly XColumnType = XColumnType;

  @Input({ required: true })
  currentDateFilter: string;

  @Input({ required: true })
  rows: DataRow[];

  @Input({ required: true })
  xColumn: XColumn;

  @Input()
  height: string;

  @Input({ required: true })
  captionTranslationKey: string;

  toISOStringPreserveTimeZone = toISOStringPreserveTimeZone;
}
